<div class="section" *ngIf="hasContent || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Landing Facility Services</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="lineServiceTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Line Services
          <mat-icon (click)="openEditLandingDialog(['Line Services::'], null, 'Line Services')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="lineServiceTags.length" [items]="lineServiceTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !lineServiceTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="amenitiesTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Amenities <mat-icon (click)="openEditLandingDialog(['Amenities::'], ['Amenities::Internet'], 'Amenities')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="amenitiesTags.length" [items]="amenitiesTags" [anchorClass]="'classOverride'"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !amenitiesTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="internetTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Internet Access <mat-icon
            (click)="openEditLandingDialog(['Amenities::Internet::'], null, 'Internet')" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="internetTags.length" [items]="internetTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !internetTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="transportationTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Transportation <mat-icon
            (click)="openEditLandingDialog(['Transportation::'], null, 'Transportation')" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="transportationTags.length" [items]="transportationTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !transportationTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="creditCardTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Credit Cards <mat-icon (click)="openEditLandingDialog(['Credit Cards::'], null, 'Credit Cards')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-credit-cards *ngIf="creditCardTags.length;" [tags]="business.tags"></app-credit-cards>
          <div *ngIf="editModeSet && !creditCardTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noneReportedPlaceholder>
  <div class="data-block__value">None reported</div>
</ng-template>
